import { render, staticRenderFns } from "./PlaylistVideoPlayer.vue?vue&type=template&id=ff011d66"
import script from "./PlaylistVideoPlayer.vue?vue&type=script&lang=js"
export * from "./PlaylistVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./PlaylistVideoPlayer.vue?vue&type=style&index=0&id=ff011d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports